var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelVentAbierta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.51 10.44L14.92 4.28001L13.17 3.26001V5.29001V18.16V18.83L13.75 19.16L24.34 25.32L26.09 26.34V24.31V11.45V10.77L25.51 10.44Z",
    fill: "#B8B8B9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.93 11.45L14.33 5.29001V18.16L24.93 24.31V11.45Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.93 22.62L15.74 17.28V6.10001L14.33 5.29001V16.46V18.16L15.74 18.97L24.93 24.31V22.62Z",
    fill: "#DDDDDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.74 17.28V6.10001L14.33 5.29001V16.46V18.16L15.74 17.28Z",
    fill: "#A6A6A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.93 11.45L14.33 5.29001V18.16L24.93 24.31V11.45Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01 16.62L7.13 18.24",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.33 18.16L5.90997 25.44V12.57L14.33 5.29001",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90997 12.57L14.33 5.29001V18.16L5.90997 25.44V12.57Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelVentAbierta);
export default __webpack_public_path__ + "static/media/SelVentAbierta.48943e80464711d852aa7993d2972e15.svg";
export { ForwardRef as ReactComponent };